export enum UserProductType {
  Product = 'Product',
  AdditionalService = 'AdditionalService',
}
